"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateEnum = void 0;
function validateEnum(value, property, validValues) {
    const errors = [];
    if (!value) {
        errors.push(`${property} is missing`);
    }
    if (!validValues.includes(value)) {
        errors.push(`The ${property} '${value}' is not recognized.`);
    }
    return errors;
}
exports.validateEnum = validateEnum;
//# sourceMappingURL=validate-enum.js.map